import styled from 'styled-components';
import React from 'react';
import { Color } from '../../../../server-types';
import { enumToHighlightColorMap, enumToPrimaryColorMap } from '../../../../utils';
import { Typography, TypographyProps } from '../../../../ui-kit';

export const CategoryColorMarker = styled.div<{ color: Color }>`
    ${({ color, theme }) => `
        background: ${enumToPrimaryColorMap(theme, color)};
        width: ${theme.spacing(4.5)}px;
        height: ${theme.spacing(4.5)}px;
        border-radius: ${theme.shape.borderRadius}px;
    `}
`;

export const SubCategoryColorMarker = styled.div<{ color: Color }>`
    ${({ color, theme }) => `
        background: ${enumToHighlightColorMap[color]};
        width: ${theme.spacing(4.5)}px;
        height: ${theme.spacing(4.5)}px;
        border-radius: 50%;
        position: relative;
        &:after {
            content: '';
            display: block;
            background: ${enumToPrimaryColorMap(theme, color)};
            width: ${theme.spacing(2)}px;
            height: ${theme.spacing(2)}px;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    `}
`;

interface ColoredClickableTypographyProps extends TypographyProps {
    textColor: Color;
}

export const ColoredClickableTypography = styled(({ textColor, ...other }: ColoredClickableTypographyProps) => (
    <Typography {...other} />
))`
    ${({ textColor, theme }) => `
        color: ${enumToPrimaryColorMap(theme, textColor)};
    `}
`;